import { useState, useEffect } from "react";
import { Plus, ArrowLeft, PenLine, X, MapPin, Users, Clock } from "lucide-react";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";
import { Campo } from "./SigteFormField";

var BLANK = {nombre:"",direccion:"",admin:"",horario:""};
var DIAS_SEMANA = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado","Domingo"];

// Rediseno Bloque 3: sigte-prototipo.jsx:806-921 (Edificios) -- coincide de
// entrada con nuestra estructura (grid de tarjetas + Editar/Eliminar inline +
// formulario aparte). Porteo directo: tarjeta linea 881-914 (PenLine/X en vez
// de texto), confirmacion inline por tarjeta linea 892-898 (ya no
// <ConfirmModal>). El selector dia/hora del horario (no existe en el
// prototipo, es nuestro) se mantiene igual, solo reskineado.
export function SigteEdificios(p) {
  var cliente = p.cliente;
  var [edificios,setEdificios]=useState([]);
  var [loading,setLoading]=useState(true);
  var [view,setView]=useState("list");
  var [editing,setEditing]=useState(null);
  var [form,setForm]=useState(BLANK);
  var [err,setErr]=useState("");
  var [confirmDeleteId,setConfirmDeleteId]=useState(null);
  var [editandoHorario,setEditandoHorario]=useState(true);
  var [diaDesde,setDiaDesde]=useState("");
  var [diaHasta,setDiaHasta]=useState("");
  var [horaDesde,setHoraDesde]=useState("");
  var [horaHasta,setHoraHasta]=useState("");

  function resetHorarioSelector(){
    setDiaDesde(""); setDiaHasta(""); setHoraDesde(""); setHoraHasta("");
  }

  function load(){
    sigteApiFetch("/edificios?cliente_id="+cliente.id).then(function(r){return r.json();}).then(function(d){
      setEdificios(d.edificios||[]); setLoading(false);
    });
  }
  useEffect(load,[cliente.id]);

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }

  function startNew(){ setEditing(null); setForm(BLANK); setErr(""); resetHorarioSelector(); setEditandoHorario(true); setView("edit"); }
  function startEdit(ed){
    setEditing(ed); setForm(Object.assign({},BLANK,ed)); setErr(""); resetHorarioSelector();
    setEditandoHorario(!ed.horario);
    setView("edit");
  }

  async function save(){
    if(!form.nombre.trim()){setErr("El nombre es requerido.");return;}
    var horario = form.horario;
    if(editandoHorario){
      var camposHorario = [diaDesde,diaHasta,horaDesde,horaHasta];
      var algunoLleno = camposHorario.some(function(v){return v;});
      var todosLlenos = camposHorario.every(function(v){return v;});
      if(algunoLleno && !todosLlenos){
        setErr("Completa dia desde, dia hasta, hora desde y hora hasta, o deja el horario vacio.");
        return;
      }
      horario = todosLlenos ? (diaDesde+" a "+diaHasta+" de "+horaDesde+" a "+horaHasta) : "";
    }
    var formConHorario = Object.assign({},form,{horario:horario});
    var path = editing ? "/edificios/"+editing.id : "/edificios";
    var method = editing ? "PUT" : "POST";
    var body = editing ? formConHorario : Object.assign({},formConHorario,{cliente_id:cliente.id});
    try {
      await sigteApiFetchChecked(path,{method:method,body:JSON.stringify(body)});
      setView("list"); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  async function del(ed){
    try {
      await sigteApiFetchChecked("/edificios/"+ed.id,{method:"DELETE"});
      setConfirmDeleteId(null); load();
    } catch(e) {
      setErr(e.message); setConfirmDeleteId(null);
    }
  }

  if(loading) return <p className="text-sm text-neutral-500">Cargando...</p>;

  return (
    <div className="space-y-6">
      <button onClick={p.onBack} className="inline-flex items-center gap-1 text-sm font-medium text-neutral-500 hover:text-neutral-900">
        <ArrowLeft size={16}/> Volver a Clientes
      </button>
      {view==="edit"?(
        <div className="space-y-6">
          <h1 className="text-2xl font-semibold tracking-tight text-neutral-900">{editing?"Editar edificio":"Nuevo edificio"}</h1>
          <div className="rounded-2xl border border-neutral-200 bg-white p-5">
            {err?<div className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">{err}</div>:null}
            <div className="grid gap-3 sm:grid-cols-2">
              <Campo label="Nombre del edificio" value={form.nombre} onChange={function(v){setF("nombre",v);}} placeholder="Torre A" className="sm:col-span-2"/>
              <Campo label="Administrador" value={form.admin} onChange={function(v){setF("admin",v);}} placeholder="Nombre del administrador"/>
              <Campo label="Dirección" value={form.direccion} onChange={function(v){setF("direccion",v);}} placeholder="Calle, número" className="sm:col-span-2"/>
              <div className="sm:col-span-2">
                <label className="mb-1 block text-xs font-medium text-neutral-500">Horario</label>
                {!editandoHorario?(
                  <div>
                    <div className="rounded-lg border border-neutral-200 bg-neutral-50 px-3 py-2 text-sm text-neutral-700">{form.horario||"Sin horario"}</div>
                    <button type="button" onClick={function(){setEditandoHorario(true);}} className="mt-1.5 text-xs font-medium text-neutral-700 hover:text-neutral-900">Reemplazar horario</button>
                  </div>
                ):(
                  <div>
                    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
                      <div>
                        <label className="mb-1 block text-[11px] text-neutral-400">Día desde</label>
                        <select value={diaDesde} onChange={function(e){setDiaDesde(e.target.value);}}
                          className="w-full rounded-lg border border-neutral-200 bg-white px-2.5 py-2 text-sm text-neutral-900 focus:border-neutral-400 focus:outline-none">
                          <option value="">...</option>
                          {DIAS_SEMANA.map(function(d){return <option key={d} value={d}>{d}</option>;})}
                        </select>
                      </div>
                      <div>
                        <label className="mb-1 block text-[11px] text-neutral-400">Día hasta</label>
                        <select value={diaHasta} onChange={function(e){setDiaHasta(e.target.value);}}
                          className="w-full rounded-lg border border-neutral-200 bg-white px-2.5 py-2 text-sm text-neutral-900 focus:border-neutral-400 focus:outline-none">
                          <option value="">...</option>
                          {DIAS_SEMANA.map(function(d){return <option key={d} value={d}>{d}</option>;})}
                        </select>
                      </div>
                      <Campo label="Hora desde" type="time" value={horaDesde} onChange={setHoraDesde}/>
                      <Campo label="Hora hasta" type="time" value={horaHasta} onChange={setHoraHasta}/>
                    </div>
                    {editing&&editing.horario?(
                      <button type="button" onClick={function(){setEditandoHorario(false); resetHorarioSelector();}} className="mt-1.5 text-xs font-medium text-neutral-500 hover:text-neutral-700">Cancelar, conservar horario anterior</button>
                    ):null}
                  </div>
                )}
              </div>
            </div>
            <button onClick={save} disabled={!form.nombre.trim()}
              className="mt-5 w-full rounded-xl bg-neutral-900 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-neutral-700 disabled:opacity-30 sm:w-auto">
              Guardar edificio
            </button>
          </div>
        </div>
      ):(
        <div className="space-y-6">
          <header className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <h1 className="text-2xl font-semibold tracking-tight text-neutral-900">{"Edificios de "+cliente.nombre}</h1>
              <p className="mt-1 text-sm text-neutral-500">{edificios.length+" edificios"}</p>
            </div>
            <button onClick={startNew} className="inline-flex items-center gap-1.5 rounded-xl bg-neutral-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-700">
              <Plus size={16}/> Nuevo edificio
            </button>
          </header>
          {err?<div className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">{err}</div>:null}
          <div className="grid gap-4 md:grid-cols-2">
            {edificios.map(function(ed){
              return (
                <div key={ed.id} className="rounded-2xl border border-neutral-200 bg-white p-5">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <h2 className="truncate text-base font-semibold text-neutral-900">{ed.nombre}</h2>
                    </div>
                    <div className="flex shrink-0 items-center gap-1">
                      <button onClick={function(){startEdit(ed);}} className="rounded-lg p-1.5 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"><PenLine size={15}/></button>
                      <button onClick={function(){setConfirmDeleteId(ed.id);}} className="rounded-lg p-1.5 text-neutral-400 hover:bg-red-50 hover:text-red-600"><X size={15}/></button>
                    </div>
                  </div>
                  {confirmDeleteId===ed.id?(
                    <div className="mt-2 flex flex-wrap items-center gap-2 rounded-lg bg-red-50 px-3 py-2">
                      <span className="text-xs text-red-700">¿Eliminar edificio y sus equipos?</span>
                      <button onClick={function(){del(ed);}} className="text-xs font-medium text-red-700 underline">Sí</button>
                      <button onClick={function(){setConfirmDeleteId(null);}} className="text-xs font-medium text-neutral-500">No</button>
                    </div>
                  ):null}
                  <dl className="mt-4 space-y-1.5 text-xs text-neutral-500">
                    <div className="flex items-center gap-2"><MapPin size={13} className="shrink-0"/>{ed.direccion||"Sin dirección"}</div>
                    <div className="flex items-center gap-2"><Users size={13} className="shrink-0"/>{ed.admin||"Sin administrador"}</div>
                    <div className="flex items-center gap-2"><Clock size={13} className="shrink-0"/>{ed.horario||"Sin horario"}</div>
                  </dl>
                  <div className="mt-4 border-t border-neutral-100 pt-3">
                    <button onClick={function(){p.onOpenEdificio(ed);}} className="text-xs font-medium text-neutral-700 hover:text-neutral-900">Ver equipos →</button>
                  </div>
                </div>
              );
            })}
            {edificios.length===0?<p className="text-sm text-neutral-400">No hay edificios registrados.</p>:null}
          </div>
        </div>
      )}
    </div>
  );
}
